module.exports = __webpack_public_path__ + "static/media/singleLeaf.bcf3c7e7.svg";